import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("pw_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("pw_token");
  }
}

const saved = typeof window !== "undefined" ? localStorage.getItem("pw_token") : null;
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
